import { createSlice } from '@reduxjs/toolkit'

const initState = {
  url: '',
  ios: false,
  iosReady: false,
  loaded: false,
}

export const wechatSlice = createSlice({
  name: 'wechat',
  initialState: initState,
  reducers: {
    updateWechatState: (state, action) => {
      return action.payload
    },
  }
})

export const { updateWechatState } = wechatSlice.actions
export default wechatSlice.reducer